import React from "react";

export default function ColorFrame26({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <g clipPath="url(#clip0_2256_162127)">
          <path
            fill="#2A3255"
            d="M252.854 241.206c2.596-2.211 8.79-6.321 11.307-12.011 9.736-22.012-1.408-67.069-44.835-122.406C168.498 34.954 40.933-12.723 22.707 56.439 32.05-6.922 150.09 22.584 208.168 83.823c53.748 56.674 74.214 125.817 56.322 149.227-2.242 2.933-7.686 7.817-11.636 8.155z"
          ></path>
          <path
            fill="#2A3255"
            d="M267.832 225.604c-1.018 1.267-1.972 2.265-2.889 3.43-2.047 2.599-3.978 5.177-6.53 7.384-4.783 4.138-10.611 8.455-24.221 12.037-25.151 6.268-60.667-.353-112.375-32.573C58.269 174.664 1.215 84.147 33.804 37.202c1.776-2.403 6.954-6.714 14.583-10.549 2.457-2.369-3.191.496-.135-1.58C-6.966 49.285 23.762 138.05 85.758 195.53c46.14 42.777 109.488 69.261 152.027 55.55 14.62-4.712 28.194-14.575 30.047-25.475z"
          ></path>
          <path
            fill="#2A3255"
            d="M37.766 249.23c-2.738-2.032-8.484-6.398-11.558-11.807-13.01-22.894-3.088-67.013 36.536-125.134C108.647 37.211 232.732-18.904 255.55 48.882c-18.254-64.105-129.365-25.247-183.21 39.746-49.831 60.147-66.467 124.341-46.201 152.664 2.148 3.002 7.664 7.866 11.628 7.938z"
          ></path>
          <path
            fill="#2A3255"
            d="M22.705 233.999c1.101 1.196.703-.074 1.696 1.026 4.257 6.747 6.294 8.227 8.988 10.259 5.05 3.808 10.756 7.294 24.01 9.348 24.301 3.767 60.508-4.416 109.942-40.026 50.685-37.93 94.798-109.063 87.015-157.754-1.529-9.567-4.36-18.635-11.098-25.764-2.439-2.58-8.721-7.532-17.045-10.51-2.61-2.2 4.936.586 1.747-1.28 54.197 19.967 32.003 111.082-26.005 172.585-43.17 45.771-104.603 76.438-147.964 65.608-15.32-3.173-28.706-12.741-31.286-23.492z"
          ></path>
          <circle cx="26.434" cy="42.583" r="13.873" fill="#E2A5FF"></circle>
          <ellipse
            fill="#8859C2"
            rx="7.508"
            ry="7.797"
            transform="scale(-1 1) rotate(-76.536 -95.255 188.66)"
          ></ellipse>
          <ellipse
            fill="#8859C2"
            rx="7.508"
            ry="7.797"
            transform="scale(-1 1) rotate(-76.536 136.854 132.097)"
          ></ellipse>
          <circle
            cx="181.24"
            cy="207.505"
            r="10.702"
            fill="#7A6FF7"
            transform="rotate(13.641 181.24 207.505)"
          ></circle>
          <circle
            cx="266.83"
            cy="223.52"
            r="7.009"
            fill="#9B27AF"
            transform="rotate(24.811 266.83 223.52)"
          ></circle>
          <path
            fill="#E9BAFF"
            d="M32.667 51.642c-3.134 2.572-9.1 2.663-13.344-1.107-3.54-3.449-3.342-8.907-1.803-11.646.609 1.058 2.562 5.094 6.203 8.026 4.377 3.525 8.58 4.671 8.944 4.727z"
          ></path>
          <path
            fill="#A577DE"
            d="M251.661 49.25c-1.254 1.812-1.038 5.05 1.194 7.182 2.027 1.764 4.975 1.414 6.391.458-.601-.283-2.874-1.162-4.625-3.004-2.105-2.215-2.913-4.442-2.96-4.636zM18.586 231.587c-1.254 1.813-1.038 5.051 1.194 7.182 2.027 1.764 4.976 1.415 6.391.459-.6-.283-2.874-1.162-4.625-3.004-2.105-2.216-2.913-4.442-2.96-4.637z"
          ></path>
          <path
            fill="#9288FE"
            d="M185.871 213.74c-2.739 1.882-7.435 2.249-10.579-.644-1.977-2.023-2.937-5.288-1.462-8.195.643 1.972 2.673 4.647 4.606 5.935 3.568 2.379 7.153 2.848 7.435 2.904z"
          ></path>
          <path
            fill="#B150D2"
            d="M269.974 227.982c-1.839 1.222-5.127 1.303-6.906-.362-1.443-1.351-1.59-3.363-.999-5.509.187.607 1.138 2.481 2.728 3.583 2.449 1.697 4.994 2.254 5.177 2.288z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_2256_162127">
            <path fill="#fff" d="M0 0H276V276H0z"></path>
          </clipPath>
        </defs>
        {children}
      </g>
    </svg>
  );
}
